import { TerminalInfo, PortInfo, Region } from "./terminals-model.types"
import { VesselInfo } from "./vessels-model.types"

export enum ListView {
    Ports = 'ports',
    Vessels = 'vessels'
}

export enum VesselDetailClickEvents {
    PerformanceClicked = "performance-clicked"
}

export enum ShoreContextEvent {
    VesselsChange = 'vessels-change',
    TerminalsChange = 'terminals-change',
    ServiceCodeChange = 'service-code-change',
    OperatorsCodeChange = 'operators-code-change',
    ClearFilters = 'clear-filters',
    VesselCLassChange = 'vessel-class-change',
    TimeLineViewToggle = 'Time-line-view-toggle'
}

export type ShoreContextInternalCache = {
    vessels: {
        list: VesselInfo[]
    }
    terminals: {
        map: Map<string, TerminalInfo>
        list: TerminalInfo[]
    }
    ports: Map<string, PortInfo>
    regions: Region[]
    services: {
        map: Map<string, Array<number>>
        list: string[]
    }
    operators: {
        map: Map<string, Array<number>>
        list: string[]
    }
}
